import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, type Document, type Entity } from "../api";
import { useCounters } from "../counters";
import { fmtDate, StatusBadge } from "../ui";

export default function Dashboard() {
  const { counters, refresh } = useCounters();
  const [entities, setEntities] = useState<Entity[]>([]);
  const [pending, setPending] = useState<Document[]>([]);
  const [recent, setRecent] = useState<Document[]>([]);

  useEffect(() => {
    api<{ entities: Entity[] }>("/entities").then((r) => setEntities(r.entities));
    api<{ documents: Document[] }>("/documents?status=pending").then((r) =>
      setPending(r.documents)
    );
    api<{ documents: Document[] }>("/documents").then((r) =>
      setRecent(r.documents.slice(0, 8))
    );
    refresh();
  }, [refresh]);

  return (
    <>
      <div className="row spread" style={{ marginBottom: 8 }}>
        <h2 style={{ margin: 0 }}>Tableau de bord</h2>
        <Link className="btn btn-primary sm" to="/documents/new">
          + Document
        </Link>
      </div>

      {pending.length > 0 && (
        <>
          <div className="section-h">À valider</div>
          <div className="doc-list">
            {pending.map((d) => (
              <DocCard key={d.id} d={d} />
            ))}
          </div>
        </>
      )}

      <div className="section-h">Entités</div>
      <div>
        {entities.map((e) => {
          const n = counters.pending_by_entity[e.id] || 0;
          return (
            <Link key={e.id} to={`/entity/${e.id}`} className="card tap">
              <div className="row spread">
                <div>
                  <div style={{ fontFamily: "var(--font-serif)", fontSize: "1.05rem", color: "var(--navy)", fontWeight: 600 }}>
                    {e.name}
                  </div>
                  <div className="tiny">{e.short_code} · {e.kind}</div>
                </div>
                <div className="row" style={{ gap: 10 }}>
                  {n > 0 && <span className="pill lg" title={`${n} document(s) à valider`}>{n}</span>}
                  <span style={{ color: "var(--ink-faint)", fontSize: 24 }}>›</span>
                </div>
              </div>
            </Link>
          );
        })}
      </div>

      <div className="section-h">Récents</div>
      <div className="doc-list">
        {recent.map((d) => (
          <DocCard key={d.id} d={d} />
        ))}
        {recent.length === 0 && <p className="muted">Aucun document.</p>}
      </div>
    </>
  );
}

function DocCard({ d }: { d: Document }) {
  return (
    <Link to={`/documents/${d.id}`} className="card tap doc-row">
      <div className="title">{d.title}</div>
      <div className="meta">
        <span className="entity-chip">{d.entity_code}</span>
        <StatusBadge s={d.status} />
        <span className="tiny">{fmtDate(d.updated_at)}</span>
      </div>
    </Link>
  );
}
